/**
 * Represents a Least Recently Used (LRU) Map.
 * Extends the built-in Map class.
 */
export class LruMap extends Map {
    /**
     *
     * @param size
     * @internal
     */
    constructor(size) {
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    /**
     *
     * @param key
     * @param value
     * @internal
     */
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            this.delete(this.keys().next().value);
        }
        return this;
    }
}
//# sourceMappingURL=lru.js.map